const $ = jQuery.noConflict();
let page = 1;
let isLoading = false;
// eslint-disable-next-line no-unused-vars
let loadingData = false; // Track if data is currently loading
const allRestaurants = [];

import storeMap from './storeMap';
import restaurantMap from './restaurantMap';

'use strict';
const map = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		if ($('.js-map').length > 0 || $('.js-restaurant-map').length > 0) {
			this.initDom();
		}
		if ($('.js-map').length > 0 && $('.js-restaurant-map').length < 1) {
			// show all retailers
			map.sendRequest();
		}
		if ($('.js-restaurant-map').length > 0) {
			map.getRestaurants();
			$(window).scroll(map.onScroll);
		}
	},

	// set $dom variables
	initDom: ()=>{
		map.$domLoader = $('.js-loader');
	},


	sendRequest: ()=> {
		$.ajax({
			url: window.fwsLocalized.ajaxUrl,
			type: 'POST',
			dataType: 'JSON',
			data: {
				action: 'load-trucks',
			},
			success: (response)=> {
				// pin markers on map
				storeMap.addMarkersFromResponse(response);
			},
		});
	},


	getRestaurants: function() {
		if (isLoading) {
			return;
		}
		isLoading = true;
		$('.js-loader').show();
		$.ajax({
			url: window.fwsLocalized.ajaxUrl,
			type: 'POST',
			dataType: 'JSON',
			data: {
				action: 'load-restaurants',
				page: page,
				perPage: 20
			},
			success: (response)=> {
				// pin markers on map
				if($('.ajax-loaded_restaurant-cards').length < 1){
					$('.restaurant-guide-post_cards').find('.restaurant-guide-block__card').remove();
				}
				response.PreparedData.forEach(element => {
					allRestaurants.push(element);
				});
				//restaurantMap.renderRestaurants(response);
				$('.currently-found_restaurants').html($('.ajax-loaded_restaurant-cards').length);
				restaurantMap.addMarkersFromResponse(allRestaurants);
			},
			complete: ()=> {
				page++;
				loadingData = false;
				isLoading = false;
				$('.js-loader').hide();
			}
		});
	}
};

export default map;
